/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Instructions_And_CredentialsInputs */

const en_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions & Credentials`)
};

const es_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones y Credenciales`)
};

const fr_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions et Identifiants`)
};

const de_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anweisungen & Zugangsdaten`)
};

const ja_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手順と認証情報`)
};

const zh_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用说明与凭证`)
};

const ar_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعليمات وبيانات الدخول`)
};

const id_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruksi & Kredensial`)
};

const it_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzioni & Credenziali`)
};

const ru_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструкции и учетные данные`)
};

const pt_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruções e Credenciais`)
};

const ko_instructions_and_credentials = /** @type {(inputs: Instructions_And_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용 안내 및 접속 정보`)
};

/**
* | output |
* | --- |
* | "Instructions & Credentials" |
*
* @param {Instructions_And_CredentialsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const instructions_and_credentials = /** @type {((inputs?: Instructions_And_CredentialsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Instructions_And_CredentialsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_instructions_and_credentials(inputs)
	if (locale === "es") return es_instructions_and_credentials(inputs)
	if (locale === "fr") return fr_instructions_and_credentials(inputs)
	if (locale === "de") return de_instructions_and_credentials(inputs)
	if (locale === "ja") return ja_instructions_and_credentials(inputs)
	if (locale === "zh") return zh_instructions_and_credentials(inputs)
	if (locale === "ar") return ar_instructions_and_credentials(inputs)
	if (locale === "id") return id_instructions_and_credentials(inputs)
	if (locale === "it") return it_instructions_and_credentials(inputs)
	if (locale === "ru") return ru_instructions_and_credentials(inputs)
	if (locale === "pt") return pt_instructions_and_credentials(inputs)
	return ko_instructions_and_credentials(inputs)
});